export const TEXT_KEYS = {
    REWARD_DESCRIPTION: 'invitee-page__reward-description',
};
